import { create } from 'zustand';

interface AppSessionStoreState {
  attachmentPreview: string | null;
  isCurrentlySelectedTabEmpty: boolean;
  isEmptySearch: boolean;
  isNotificationCenterVisible: boolean;
  isProfileVisible: boolean;
  setAttachmentPreview: (value: string | null) => void;
  setIsCurrentlySelectedTabEmpty: (value: boolean) => void;
  setIsEmptySearch: (value: boolean) => void;
  setIsNotificationCenterVisible: (value: boolean) => void;
  setIsProfileVisible: (value: boolean) => void;
}

export const useAppSessionStore = create<AppSessionStoreState>(set => ({
  attachmentPreview: null,
  isCurrentlySelectedTabEmpty: false,
  isEmptySearch: false,
  isNotificationCenterVisible: false,
  isProfileVisible: false,
  setAttachmentPreview: attachmentPreview => set({ attachmentPreview }),
  setIsCurrentlySelectedTabEmpty: isCurrentlySelectedTabEmpty => set({ isCurrentlySelectedTabEmpty }),
  setIsEmptySearch: isEmptySearch => set({ isEmptySearch }),
  setIsNotificationCenterVisible: isNotificationCenterVisible => set({ isNotificationCenterVisible }),
  setIsProfileVisible: isProfileVisible => set({ isProfileVisible }),
}));
